import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    RegionSecondLevel, ProductTypeCQuote,
} from 'app/enums/label.enums'
import requestConfig from 'app/requests/RateCard/RateCard.requests'

export default function useGetRateCardsData(requestData: {
    originRegion?: RegionSecondLevel,
    destinationRegion?: RegionSecondLevel,
    productType?: ProductTypeCQuote,
}) {
    return useRequest({
        key: RequestKeys.getRateCardsData,
        params: requestData,
        requestFunc: RequestFn.getEntity(requestConfig.getLogisticDetails),
        enabled: Boolean(
            requestData?.originRegion && requestData?.destinationRegion && requestData?.productType,
        ),
    })
}
